// extracted by mini-css-extract-plugin
export default {"footContainer":"Footer_footContainer__A+fze","footerContent":"Footer_footerContent__NODzU","footerContainer":"Footer_footerContainer__56waa"};